"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressList = void 0;
const immer_1 = require("immer");
const actions = __importStar(require("../../../shared/store/action_constants"));
const defaultState = {
    teamList: [],
    // selected team
    selectedTeamInfo: {
        teamTitle: '',
        teamId: '',
    },
    // member list
    memberList: [],
    // member info
    memberInfo: {
        memberId: '',
        email: '',
    },
    memberListPageNo: 1,
    memberListTotal: 0,
    memberListLoading: false,
};
const updateMemberInList = (state, payload) => {
    if (!payload.memberId) {
        return state;
    }
    return state.reduce((prev, cur) => {
        if (cur.memberId === payload.memberId) {
            prev.push(Object.assign(Object.assign({}, cur), payload));
            return prev;
        }
        prev.push(Object.assign({}, cur));
        return prev;
    }, []);
};
const findParent = (data, id) => {
    return data.reduce((preValue, item) => {
        if (preValue) {
            return preValue;
        }
        if (item.teamId === id) {
            return item;
        }
        if (item.children) {
            return findParent(item.children, id);
        }
        return null;
    }, null);
};
const getReplacedTeamList = (oldTeamList, newTeamList) => {
    const parentChildrenMap = oldTeamList.reduce((acc, item) => {
        acc.set(item.teamId, item.children);
        return acc;
    }, new Map());
    return newTeamList.map(item => {
        return Object.assign(Object.assign({}, item), { children: parentChildrenMap.get(item.teamId) || [] });
    });
};
const updateTeamTree = (originTree, parentId, childrenTree) => {
    const parent = findParent(originTree, parentId);
    if (!parent) {
        return;
    }
    if (!parent.children || parent.children.length === 0) {
        parent.children = childrenTree;
    }
    else {
        parent.children = getReplacedTeamList(parent.children, childrenTree);
    }
};
exports.addressList = (0, immer_1.produce)((data = defaultState, action) => {
    switch (action.type) {
        case actions.UPDATE_TEAM_LIST: {
            data.teamList = action.payload;
            return data;
        }
        case actions.UPDATE_MEMBER_LIST_PAGE: {
            if (data.memberListPageNo > 0) {
                const memberList = [...data.memberList, ...action.payload];
                data.memberList = memberList;
                return data;
            }
            data.memberList = action.payload;
            return data;
        }
        case actions.UPDATE_MEMBER_LIST: {
            data.memberList = action.payload;
            return data;
        }
        case actions.UPDATE_SELECTED_TEAM_INFO: {
            data.selectedTeamInfo = action.payload;
            return data;
        }
        case actions.UPDATE_MEMBER_INFO: {
            Object.assign(data.memberInfo, action.payload);
            return data;
        }
        case actions.UPDATE_SINGLE_MEMBER_IN_MEMBERLIST: {
            data.memberList = updateMemberInList(data.memberList, action.payload);
            return data;
        }
        case actions.UPDATE_ADDRESS_TREE: {
            const { parentId, childrenTree } = action.payload;
            updateTeamTree(data.teamList, parentId, childrenTree);
            return data;
        }
        case actions.UPDATE_MEMBER_LIST_TOTAL: {
            data.memberListTotal = action.payload;
            return data;
        }
        case actions.UPDATE_MEMBER_LIST_PAGE_NO: {
            data.memberListPageNo = action.payload;
            return data;
        }
        case actions.UPDATE_MEMBER_LIST_LOADING: {
            data.memberListLoading = action.payload;
            return;
        }
        default:
            return data;
    }
}, defaultState);
//# sourceMappingURL=address_list.js.map